import { Fee } from 'types/feeTypes';
import axiosInstance from './axiosInstance';
import { Expense } from 'types/expenseTypes';

export interface FinanceStats {
  totalIncome: number;
  totalExpense: number;
  pendingPayments: number;
  recentTransactions: number;
}



export interface FinanceOverview {
  overview: FinanceStats;
  recentEntries: {
    fees: Fee[];
    expenses: Expense[];
    pendingFees: Fee[];
    pendingExpenses: Expense[];
  };

}

export type FinanceDashboard = any;

export const getFinanceOverview = async () => {
  const response = await axiosInstance.get('/dashboard/financial-overview');
  return response.data
};

export const getFinanceDashboard = async (filters: any) => {
  const response = await axiosInstance.get('/dashboard/financial-dashboard', { params: filters });
  return response.data
};
